import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export function useCountdown(until: Date) {
  const [ms, setMs] = useState(() => {
    const now = dayjs();
    const end = dayjs(until);
    return end.diff(now);
  });

  const isActive = ms >= SECOND;

  useEffect(() => {
    if (isActive) {
      const interval = setInterval(() => setMs((prev) => prev - SECOND), SECOND);
      return () => {
        clearInterval(interval);
      };
    }
  }, [isActive]);

  return { ms, isActive };
}

export function parseMs(ms: number) {
  const days = Math.floor(ms / DAY);
  const hours = Math.floor((ms % DAY) / HOUR);
  const minutes = Math.floor((ms % HOUR) / MINUTE);
  const seconds = Math.floor((ms % MINUTE) / SECOND);

  const result = [days, hours, minutes, seconds] as const;

  return result;
}

export function formatTimeValue(value: number) {
  return value < 10 ? value.toString().padStart(2, '0') : value.toString();
}
